import { Component, Input } from '@angular/core'

@Component({
    selector: 'sf-sidebar-nav-divider',
    template: ``,
})
export class SidebarNavDividerComponent {
    @Input() item: any
}
